/**
 * Modal que se muestra cuando la sesión expira
 * No se puede cerrar haciendo click fuera o con Escape
 * Solo se puede cerrar haciendo click en el botón "Ir al Login"
 */

import { Modal } from '@/shared/components/Modal';
import styles from './SessionExpiredModal.module.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function SessionExpiredModal({ isOpen, onClose }: Props) {
  const handleGoToLogin = () => {
    onClose();
    // Normalizamos la base para que no haya problemas de dobles barras
    const base = import.meta.env.BASE_URL;
    const cleanBase = base.endsWith('/') ? base : `${base}/`;

    // Redirección forzada al login
    window.location.href = `${cleanBase}#/auth/login`;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Sesión Expirada"
      showCloseButton={false}
      allowClose={false}
    >
      <div className={styles.content}>
        <p className={styles.message}>
          Su sesión ha expirado por seguridad. Por favor, inicie sesión nuevamente para continuar.
        </p>
        <button
          type="button"
          onClick={handleGoToLogin}
          className={styles.loginButton}
          autoFocus
        >
          Ir al Login
        </button>
      </div>
    </Modal>
  );
}

